// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1gD4r","title":"FrontImage_title__ev4co"};